import { tariffsApi } from '../client';
import type { components } from '../generated/schema';

export type BalanceGetResponse = components['schemas']['BalanceGetResponse'];
export type BalanceUpdateRequest = components['schemas']['BalanceUpdateRequest'];

export async function fetchUserBalance(userId: number): Promise<BalanceGetResponse> {
  const { data, error } = await tariffsApi.GET('/balances/{user_id}', {
    params: { path: { user_id: userId } },
  });
  if (error) throw error;
  return data!;
}

export async function updateUserBalance(body: BalanceUpdateRequest): Promise<boolean> {
  const { data, error } = await tariffsApi.PUT('/balances/', { body });
  if (error) throw error;
  return data?.response ?? true;
}
